import * as React from 'react';

const RobinhoodGoldCardLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={186} height={20} fill='none' {...props}>
    <path fill='url(#a)' d='M53.5 3.061h-1.957v2.093h1.958V3.061Z' />
    <path
      fill='url(#b)'
      d='M115.792 11.306h3.201c-.133 2.675-1.867 3.852-3.815 3.852-2.321 0-3.669-1.845-3.669-5.042s1.374-5.07 3.842-5.07c1.721 0 3.095.923 3.322 2.635h2.001c-.28-2.808-2.388-4.24-5.336-4.24-3.802 0-5.896 2.662-5.896 6.661 0 4 1.894 6.648 5.549 6.648 1.854 0 2.962-.682 3.722-1.779.093-.107.173-.2.294-.2.133 0 .24.093.24.294v1.471h1.507V9.768h-4.962v1.538Z'
    />
    <path
      fill='url(#c)'
      d='M126.904 7.066c-2.708 0-4.362 1.752-4.362 4.829 0 3.076 1.654 4.815 4.362 4.815s4.335-1.753 4.335-4.816c0-3.062-1.614-4.828-4.335-4.828Zm0 8.226c-1.708 0-2.388-1.418-2.388-3.397 0-1.98.68-3.398 2.388-3.398 1.707-.013 2.388 1.391 2.388 3.398 0 2.006-.681 3.397-2.388 3.397Z'
    />
    <path fill='url(#d)' d='M134.908 3.227h-1.854v13.309h1.854V3.227Z' />
    <path
      fill='url(#e)'
      d='M143.406 3.134v4.788c0 .187-.107.28-.24.28-.094 0-.227-.093-.28-.146-.667-.71-1.388-1.07-2.522-1.07-2.014 0-3.655 1.551-3.655 4.868s1.641 4.856 3.655 4.856c1.174 0 1.908-.455 2.615-1.164.107-.107.187-.174.28-.174.134 0 .24.094.24.281v.883h1.774V3.134h-1.867Zm-2.335 12.144c-1.721.014-2.414-1.417-2.414-3.424 0-2.006.693-3.424 2.414-3.424s2.415 1.405 2.415 3.424c0 2.02-.667 3.425-2.415 3.425Z'
    />
    <path
      fill='url(#f)'
      d='M36.738 6.986c-2.721 0-4.389 1.766-4.389 4.869 0 3.103 1.668 4.855 4.39 4.855 2.72 0 4.375-1.766 4.375-4.855 0-3.09-1.628-4.869-4.376-4.869Zm0 8.306c-1.72 0-2.414-1.418-2.414-3.424.013-2.033.694-3.437 2.414-3.437 1.721 0 2.415 1.404 2.415 3.424s-.694 3.437-2.415 3.437Z'
    />
    <path
      fill='url(#g)'
      d='M61.671 6.986c-1.347 0-2.134.615-2.721 1.404-.08.094-.147.188-.28.188-.134 0-.24-.094-.24-.281V7.173h-1.761v9.363h1.867v-5.163c0-1.672.894-2.862 2.295-2.862 1.32 0 1.974.762 1.974 2.42v5.605h1.868v-6.1c0-2.153-.974-3.45-3.002-3.45Z'
    />
    <path
      fill='url(#h)'
      d='M71.65 6.986c-1.254 0-2.068.561-2.615 1.27-.08.094-.147.188-.28.188-.134 0-.24-.094-.24-.281v-5.03h-1.868v13.403h1.868v-5.163c0-1.672.893-2.863 2.294-2.863 1.32 0 1.975.763 1.975 2.421v5.605h1.867v-6.1c0-2.153-.974-3.45-3.001-3.45Z'
    />
    <path
      fill='url(#i)'
      d='M80.48 6.986c-2.721 0-4.389 1.766-4.389 4.869 0 3.103 1.668 4.855 4.389 4.855s4.376-1.766 4.376-4.855c-.014-3.103-1.628-4.869-4.376-4.869Zm0 8.306c-1.72 0-2.415-1.418-2.415-3.424 0-2.006.694-3.424 2.415-3.424 1.72 0 2.414 1.404 2.414 3.424-.013 1.993-.693 3.424-2.414 3.424Z'
    />
    <path
      fill='url(#j)'
      d='M90.272 6.986c-2.721 0-4.389 1.766-4.389 4.869 0 3.103 1.668 4.855 4.39 4.855 2.72 0 4.375-1.766 4.375-4.855 0-3.09-1.628-4.869-4.376-4.869Zm0 8.306c-1.72 0-2.414-1.418-2.414-3.424 0-2.006.693-3.424 2.414-3.424s2.415 1.404 2.415 3.424-.694 3.424-2.415 3.424Z'
    />
    <path fill='url(#k)' d='M54.64 7.173h-1.867v9.363h1.867V7.173Z' />
    <path fill='url(#l)' d='M54.694 3.133h-2v2.14h2v-2.14Z' />
    <path
      fill='url(#m)'
      d='M102.412 7.922c0 .187-.107.28-.24.28-.094 0-.227-.093-.281-.146-.667-.71-1.387-1.07-2.52-1.07-2.015 0-3.656 1.551-3.656 4.868s1.64 4.855 3.655 4.855c1.174 0 1.908-.454 2.615-1.163.107-.107.187-.174.28-.174.133 0 .24.094.24.28v.884h1.774V3.133h-1.867v4.789Zm-2.335 7.356c-1.72.014-2.414-1.418-2.414-3.424 0-2.006.693-3.424 2.414-3.424s2.415 1.404 2.415 3.424-.667 3.424-2.415 3.424Z'
    />
    <path
      fill='url(#n)'
      d='M47.57 6.986c-1.133 0-1.853.36-2.52 1.07-.054.053-.187.147-.28.147-.134 0-.24-.094-.24-.281V3.133h-1.868v13.403h1.76v-.883c0-.188.107-.281.24-.281.094 0 .174.053.28.174.708.709 1.441 1.163 2.615 1.163 2.015 0 3.669-1.538 3.669-4.855s-1.64-4.868-3.655-4.868Zm-.72 8.306c-1.734 0-2.414-1.418-2.414-3.425 0-2.006.667-3.424 2.414-3.424 1.748 0 2.415 1.405 2.415 3.425 0 1.992-.694 3.424-2.415 3.424Z'
    />
    <path
      fill='url(#o)'
      d='M29.414 10.57c-.147-.053-.2-.147-.2-.267 0-.134.053-.187.227-.281 1.014-.481 1.627-1.445 1.627-2.755 0-2.3-1.44-3.692-4.335-3.692h-4.99v12.96h1.975v-5.35h3.188c1.508 0 2.015.643 2.055 1.686l.186 3.665h1.948l-.2-3.799c-.08-1.257-.574-1.832-1.48-2.167ZM26.6 9.648h-2.881V5.153h2.881c1.494 0 2.415.736 2.415 2.247 0 1.512-.92 2.248-2.415 2.248Z'
    />
    <path
      fill='url(#p)'
      d='M9.866 4.511H5.811a.457.457 0 0 0-.373.187L2.529 8.31c-.426.535-.533 1.03-.533 1.739v3.691c-.947 2.662-1.548 4.468-1.988 6.1-.027.104.013.16.107.16h.44c.08 0 .16-.04.187-.107 3.321-8.48 6.937-12.68 9.204-15.195.094-.107.054-.187-.08-.187Z'
    />
    <path
      fill='url(#q)'
      d='M9.986.351a2.528 2.528 0 0 0-.653.388A34.43 34.43 0 0 0 6.57 3.388c-.093.093-.053.187.08.187h4.496c.413 0 .654.24.654.655v5.083c0 .134.106.174.186.053l2.708-3.544c.44-.575.574-.75.694-1.552.16-1.177.067-2.982-.64-3.731-.627-.67-3.455-.696-4.763-.188Z'
    />
    <path
      fill='url(#r)'
      d='M10.667 5.528C7.879 8.644 5.704 11.92 3.69 15.867c-.05.099.013.187.133.147l4.163-1.284c.47-.144.733-.334.96-.709l1.854-3.063a.565.565 0 0 0 .054-.24v-5.11c0-.134-.094-.187-.187-.08Z'
    />
    <path
      fill='url(#s)'
      d='M150.835 10.06c0-4.152 2.266-6.7 5.598-6.7 2.945 0 4.713 1.79 4.971 4.467h-1.197c-.239-1.827-1.399-3.396-3.793-3.396-2.614 0-4.363 2.05-4.363 5.63s1.767 5.63 4.363 5.63c2.394 0 3.554-1.57 3.793-3.397h1.197c-.258 2.677-2.026 4.468-4.971 4.468-3.332 0-5.598-2.548-5.598-6.701Z'
    />
    <path
      fill='url(#t)'
      d='M163.134 14.104c0-1.827 1.326-2.603 3.13-2.917l1.362-.24c1.178-.203 1.529-.423 1.529-1.107 0-1.145-.94-1.81-2.339-1.81-1.234 0-2.136.407-2.228 1.754h-1.142c.074-1.938 1.602-2.75 3.37-2.75 1.933 0 3.462.885 3.462 2.99v6.517h-1.031v-1.088c0-.13-.074-.185-.147-.185-.074 0-.13.037-.239.166a3.8 3.8 0 0 1-2.817 1.273c-1.657 0-2.91-.868-2.91-2.603Zm6.114-1.33V11.39c-.239.24-.829.407-1.657.554l-1.031.185c-1.657.295-2.283.941-2.283 1.994 0 .868.571 1.588 1.787 1.588 1.694 0 3.185-1.108 3.185-2.935l-.001-.001Z'
    />
    <path
      fill='url(#u)'
      d='M172.911 7.2h1.031V8.49c0 .111.054.185.146.185s.13-.019.222-.166c.515-.83 1.435-1.477 2.485-1.477.239 0 .46.02.718.074l-.019 1.164a7.953 7.953 0 0 0-.902-.074c-1.491 0-2.577 1.2-2.577 2.917v5.428h-1.104V7.2Z'
    />
    <path
      fill='url(#v)'
      d='M178.231 11.87c0-3.175 1.638-4.836 3.774-4.836 1.123 0 1.933.424 2.541 1.107.073.074.111.13.203.13.092 0 .146-.073.146-.184V3.139H186v13.402h-1.031v-.96c0-.111-.055-.185-.147-.185s-.129.055-.203.13c-.736.85-1.675 1.181-2.614 1.181-2.136 0-3.774-1.661-3.774-4.837Zm6.775 0c0-2.196-.774-3.82-2.799-3.82s-2.798 1.624-2.798 3.82c0 2.197.773 3.822 2.798 3.822s2.799-1.607 2.799-3.822Z'
    />
    <defs>
      <linearGradient id='a' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='b' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='c' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='d' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='e' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='f' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='g' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='h' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='i' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='j' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='k' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='l' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='m' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='n' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='o' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='p' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='q' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='r' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='s' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='t' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='u' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
      <linearGradient id='v' x1={186} x2={0} y1={10} y2={10} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#94814C' />
        <stop offset={1} stopColor='#CFB97D' />
      </linearGradient>
    </defs>
  </svg>
);

export default RobinhoodGoldCardLogo;
